import { render, staticRenderFns } from "./LawSliderStudents.vue?vue&type=template&id=1baa630c&scoped=true&"
import script from "./LawSliderStudents.vue?vue&type=script&lang=js&"
export * from "./LawSliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./LawSliderStudents.vue?vue&type=style&index=0&id=1baa630c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa630c",
  null
  
)

export default component.exports